/* istanbul ignore file */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import ContextMenu from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenu';
import ContextMenuItem
  from '@avtechsoftware/react-component-library/src/components/common/ContextMenu/ContextMenuItem/ContextMenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import tagPropType from '../../../../../../../utility/PropTypes/tagPropType';
import tagType from '../../../../../../../utility/types/tagType';
import { connectModalContainerContextToComponent } from '../../../../../../../contexts/ModalContext/ModalContext';
import DeleteConfirmationModal from '../../../../../../common/DeleteConfirmationModal';
import {
  deleteTag,
  selectTagListCrudOperation,
  selectTagListCrudStatus,
} from '../../../../../../../redux/slices/tagListSlice/tagListSlice';
import { CrudType } from '../../../../../../../utility/types/CrudType';
import { CrudStatus } from '../../../../../../../utility/types/CrudStatus';
import EditTagModal from '../../../../modals/EditTagModal/EditTagModal';
import { RaaRoles } from '../../../../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../../../../highorder/HasRolePrivileges';

import SearchType from '../../../../../../../utility/types/SearchType';
import { setAppliedAlertSearch } from '../../../../../../../redux/slices/alertListSlice/alertListSlice';
import {
  setAppliedDeviceSearch,
} from '../../../../../../../redux/slices/filteredDeviceListSlice/filteredDeviceListSlice';

function TagListRow({
  tag,
  icon,
  iconTooltip,
  setModalJSX,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const crudOperation = useSelector(selectTagListCrudOperation);
  const crudStatus = useSelector(selectTagListCrudStatus);

  const deleteInProgress = crudOperation === CrudType.DELETE
      && crudStatus === CrudStatus.PENDING;

  return (
    <>
      <tr>
        <td>{icon ? <span title={iconTooltip}><FontAwesomeIcon icon={icon} style={{ marginLeft: '0.75rem' }} /></span> : ' '}</td>
        <td>{tag.name}</td>
        <td>
          <button
            type="button"
            className="btn btn-link"
            title="View in alerts list"
            onClick={() => {
              dispatch(setAppliedAlertSearch({
                id: null,
                name: null,
                description: '',
                type: SearchType.ALERT,
                filters: [{
                  facetId: 3,
                  operatorId: 4,
                  value1: tag.id,
                  value2: null,
                }],
              }));
              history.push('/s/alerts');
            }}
          >
            {tag.alertCount}
          </button>
        </td>
        <td>
          <button
            type="button"
            title="View in device list"
            className="btn btn-link"
            onClick={() => {
              dispatch(setAppliedDeviceSearch({
                id: null,
                name: null,
                description: '',
                type: SearchType.DEVICE,
                filters: [{
                  facetId: 6,
                  operatorId: 4,
                  value1: tag.id,
                  value2: null,
                }],
              }));
              history.push('/s/devices');
            }}
          >
            {tag.deviceCount}
          </button>
        </td>
        <td>
          {tag.type === tagType.USER_DEFINED ? (
            <ContextMenu classname="overflow-visible">
              <>
                <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
                  <ContextMenuItem
                    itemIcon="pencil"
                    itemText="Edit"
                    onClickHandler={(event) => {
                      event.stopPropagation();
                      setModalJSX(
                        <EditTagModal tag={tag} />,
                      );
                    }}
                  />
                  <ContextMenuItem
                    itemIcon="trash"
                    itemText="Delete"
                    onClickHandler={(event) => {
                      event.stopPropagation();
                      setModalJSX(
                        <DeleteConfirmationModal
                          itemName={tag.name}
                          handleDelete={() => {
                            dispatch(deleteTag(tag.id));
                            setModalJSX(<></>);
                          }}
                          isButtonDisabled={deleteInProgress}
                        />,
                      );
                    }}
                  />
                </HasRolePrivileges>
              </>
            </ContextMenu>
          )
            : (<ContextMenu disabled />)}
        </td>
      </tr>
    </>
  );
}

TagListRow.defaultProps = {
  icon: null,
  iconTooltip: null,
};

TagListRow.propTypes = {
  tag: PropTypes.shape(tagPropType).isRequired,
  icon: PropTypes.node,
  iconTooltip: PropTypes.string,
  setModalJSX: PropTypes.func.isRequired,
};

export default connectModalContainerContextToComponent(TagListRow);
